
<div class="shopReviewForm">
  <div class="shopReviewForm__container">
    <div class="ui warning message" v-if="form.hasErrors()">
      <ul class="list">
        <li v-if="form.hasError('access_rating')">評価(アクセス)を選択してください</li>
        <li v-if="form.hasError('room_rating')">評価(会場)を選択してください</li>
        <li v-if="form.hasError('facility_rating')">評価(設備)を選択してください</li>
        <li v-if="form.hasError('service_rating')">評価(サービス)を選択してください</li>
        <li v-if="form.hasError('food_drink_rating')">評価(料理・ドリンク)を選択してください</li>
        <li v-if="form.hasError('cost_performance_rating')">評価(コスパ)を選択してください</li>
        <li v-if="form.hasError('title')">口コミのタイトルを入力してください</li>
        <li v-if="form.hasError('contents')">口コミの本文を入力してください</li>
        <li v-if="form.hasError('is_company')">利用分類を選択してください</li>
        <li v-if="form.hasError('category')">利用カテゴリを選択してください</li>
        <li v-if="form.hasError('event_date')">利用日を選択してください</li>
        <li v-if="form.hasError('people')">利用人数を入力してください</li>
        <li v-if="form.hasError('total_price')">費用の合計を入力してください</li>
        <li v-if="form.hasError('gender')">性別を選択してください</li>
        <li v-if="form.hasError('age')">記入者の年齢を入力してください</li>
        <li v-if="form.hasError('agree_terms')">利用規約に同意してください</li>
      </ul>
    </div>
    <form class="ui form">
      <div class="shopReviewForm__heading">
        <h1 class="shopReviewForm__title">{{ shopName }}</h1>
      </div>
      <div class="shopReviewForm__section">
        <div class="shopReviewForm__section-title">各項目の評価</div>
        <div class="shopReviewForm__grid">
          <div class="shopReviewForm__grid-item">
            <div class="shopReviewForm__grid-item-label">
              <label>アクセス</label>
            </div>
            <div class="shopReviewForm__rating">
              <rating-stars v-model="form.model.access_rating"></rating-stars>
            </div>
          </div>
          <div class="shopReviewForm__grid-item">
            <div class="shopReviewForm__grid-item-label">
              <label>サービス</label>
            </div>
            <div class="shopReviewForm__rating">
              <rating-stars v-model="form.model.service_rating"></rating-stars>
            </div>
          </div>
          <div class="shopReviewForm__grid-item">
            <div class="shopReviewForm__grid-item-label">
              <label>会場</label>
            </div>
            <div class="shopReviewForm__rating">
              <rating-stars v-model="form.model.room_rating"></rating-stars>
            </div>
          </div>
          <div class="shopReviewForm__grid-item">
            <div class="shopReviewForm__grid-item-label">
              <label>料理・ドリンク</label>
            </div>
            <div class="shopReviewForm__rating">
              <rating-stars v-model="form.model.food_drink_rating"></rating-stars>
            </div>
          </div>
          <div class="shopReviewForm__grid-item">
            <div class="shopReviewForm__grid-item-label">
              <label>設備</label>
            </div>
            <div class="shopReviewForm__rating">
              <rating-stars v-model="form.model.facility_rating"></rating-stars>
            </div>
          </div>
          <div class="shopReviewForm__grid-item">
            <div class="shopReviewForm__grid-item-label">
              <label>コスパ</label>
            </div>
            <div class="shopReviewForm__rating">
              <rating-stars v-model="form.model.cost_performance_rating"></rating-stars>
            </div>
          </div>
        </div>
      </div>
      <div class="shopReviewForm__section">
        <div class="shopReviewForm__section-title">口コミ記入</div>
        <div class="shopReviewForm__row fields" :class="{'error': form.hasError('title')}">
          <input type="text" v-model="form.model.title" placeholder="タイトルを入力してください" />
        </div>
        <div class="shopReviewForm__row fields" :class="{'error': form.hasError('contents')}">
          <textarea v-model="form.model.contents" placeholder="口コミの本文を入力してください"></textarea>
        </div>
      </div>
      <div class="shopReviewForm__section">
        <div class="shopReviewForm__section-title">情報記入</div>
        <div class="shopReviewForm__row fields">
          <div class="shopReviewForm__label">
            <div class="shopReviewForm__required-icon">必須</div>
            <label>利用分類</label>
          </div>
          <div class="shopReviewForm__choice">
            <input type="radio" v-model="form.model.is_company" id="is_company_no" :value=false /><label for="is_company_no">個人利用</label>
            <input type="radio" v-model="form.model.is_company" id="is_company_yes" :value=true /><label for="is_company_yes">法人利用</label>
          </div>
        </div>
        <div class="shopReviewForm__row fields" :class="{'error': form.hasError('category')}">
          <div class="shopReviewForm__label">
            <div class="shopReviewForm__required-icon">必須</div>
            <label>利用カテゴリ</label>
          </div>
          <dropdown v-model="form.model.category" :options="consts.MARUNAGE_CATEGORY"></dropdown>
        </div>
        <div class="shopReviewForm__row fields" :class="{'error': form.hasError('event_date')}">
          <div class="shopReviewForm__label">
            <div class="shopReviewForm__required-icon">必須</div>
            <label>利用日</label>
          </div>
          <div class="shopReviewForm__date-item" :class="{'error': form.hasError('event_date')}">
            <datepick v-model="form.model.event_date"></datepick>
          </div>
        </div>
        <div class="shopReviewForm__row fields" :class="{'error': form.hasError('people')}">
          <div class="shopReviewForm__label">
            <div class="shopReviewForm__required-icon">必須</div>
            <label>利用人数</label>
          </div>
          <input type="number" v-model="form.model.people" />
        </div>
        <div class="shopReviewForm__row fields" :class="{'error': form.hasError('total_price')}">
          <div class="shopReviewForm__label">
            <div class="shopReviewForm__required-icon">必須</div>
            <label>費用の合計</label>
          </div>
          <input type="number" v-model="form.model.total_price" />
        </div>
        <div class="shopReviewForm__row fields">
          <div class="shopReviewForm__label">
            <div class="shopReviewForm__required-icon">必須</div>
            <label>性別記入</label>
          </div>
          <div class="shopReviewForm__choice">
            <input type="radio" v-model="form.model.gender" id="female" :value=1 /><label for="female">女性</label>
            <input type="radio" v-model="form.model.gender" id="male" :value=2 /><label for="male">男性</label>
            <input type="radio" v-model="form.model.gender" id="unselected" :value=3 /><label for="unselected">未選択</label>
          </div>
        </div>
        <div class="shopReviewForm__row fields" :class="{'error': form.hasError('age')}">
          <div class="shopReviewForm__label">
            <div class="shopReviewForm__required-icon">必須</div>
            <label>記入者の年齢</label>
          </div>
          <dropdown v-model="form.model.age" :options="consts.SHOP_REVIEW_AGE"></dropdown>
        </div>
      </div>
      <div class="shopReviewForm__bottom-checkbox">
        <checkbox v-model="form.model.agree_terms" :class="{'error': form.hasError('agree_terms')}"><a href="/term/" target="_blank">利用規約</a>と<a href="/review_term/" target="_blank">ガイドライン</a>に同意する</checkbox>
      </div>
      <div class="shopReviewForm__actions">
        <button @click="save('pending')" type="button" class="shopReviewForm__btn ui orange button large detailedMarunageForm__btn" :class="{'disabled loading': form.waiting, 'disabled': !isFormComplete}">口コミを投稿する</button>
        <button @click="save('draft')" type="button" class="shopReviewForm__btn ui basic orange button large detailedMarunageForm__btn" :class="{'disabled loading': form.waiting, 'disabled': !isFormComplete}">下書きに保存する</button>
      </div>
    </form>
  </div>
</div>
